import Component from '../core/Component';

export const STATES = {
    FILLED: 'is-filled',
    FOCUSED: 'is-focused'
}

export default class Input extends Component {

    constructor(element) {
        super(element)
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)

        this.element.addEventListener('focus', this.handleFocus)
        this.element.addEventListener('blur', this.handleBlur)
    }
    
    handleChange = event => {
        if(!event.target.value) {
            this.element.classList.remove(STATES.FILLED)
        } 
        if(event.target.value.length > 0) {
            this.element.classList.add(STATES.FILLED)
        } 
    }
    
    handleFocus = event => {
        this.element.classList.add(STATES.FOCUSED)
    }

    handleBlur = event => {
        this.element.classList.remove(STATES.FOCUSED)
    }
}